import React, { useState, useEffect } from 'react';
import {
	Navbar,
	Nav,
	NavLink,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Button,
	Container,
	Row,
	Col,
	Popover,
	PopoverBody,
	NavbarToggler
} from 'reactstrap';
// import './_header.scss';
import Avatar from '@material-ui/core/Avatar';
import MediaQuery from 'react-responsive';
import SignoutButton from './signoutButton';
import QuickSearch from '../../../search/newQuickSearch';
import SearchIcon from '../../elements/icons/searchIcon';
import FacebookIcon from '../../elements/icons/facebookIcon';
import TwitterIcon from '../../elements/icons/twitterIcon';
import InstagramIcon from '../../elements/icons/instagramIcon';
import LinkedinIcon from '../../elements/icons/linkedinIcon';
import COLORS from '../../../../common/colors';
import getConfig from 'next/config';
import GiNavToggler from '../header/GiNavToggler';
import WGNavToggler from '../../../workplace/WGHeader/WGNavToggler';
import SelectByPlatform from '../../../workplace/common/selectByPlatform';
import { BurgerNavMenu } from './burgerNavMenu';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import FontAwesomeSVGIcon from '../../elements/icons/fontAwesomeSVGIcon';
import cookies from '../../../../util/cookies';
import Cookie from '../../../../util/cookies';

const config = getConfig().publicRuntimeConfig;


const LoggedInUserAvatar = React.memo((props) => {

	return (
		<Dropdown
			nav
			inNavbar
			isOpen={props.profileDropdownOpen}
			toggle={props.profileDropdownToggle}
			onMouseEnter={props.profileDropdownToggle}
			onMouseLeave={props.profileDropdownToggle}
		>
			<DropdownToggle nav>
				<div style={{marginRight: '8px'}}>
					<Avatar												
						style={{
							margin : 0,
							width: 36,
							height: 36
						}}
						src={props.user.profilePic}
					/>
					<FontAwesomeSVGIcon icon={faChevronDown} className="ml-auto" width="12px" style={{right: "-6px"}}/> 
				</div>	
			</DropdownToggle>
			<DropdownMenu style={{ top: '95%' }} right  className="profile-dropdown">
				<DropdownItem href="/user/profile" target="_blank" >Monthly Giving Profile</DropdownItem>
				<DropdownItem href={`${config.fundraisersPlatformUrl}me`} target="_blank">Fundraiser profile</DropdownItem>
				<SignoutButton session={props.session} _csrf={props._csrf} />
			</DropdownMenu>
		</Dropdown>
	)
})

const WPGLoggedInUserAvatar = React.memo((props) => {

	return (
		<Dropdown
			nav
			inNavbar
			isOpen={props.profileDropdownOpen}
			toggle={props.profileDropdownToggle}
			onMouseEnter={props.profileDropdownToggle}
			onMouseLeave={props.profileDropdownToggle}
		>
			<DropdownToggle nav>
				<div style={{marginRight: '8px'}}>
					<Avatar												
						style={{
							margin : 0,
							width: 36,
							height: 36
						}}
						src={props.user.profilePic}
					/>
					<FontAwesomeSVGIcon icon={faChevronDown} className="ml-auto" width="12px" style={{right: "-6px"}}/> 
				</div>	
			</DropdownToggle>
			<DropdownMenu style={{ top: '95%' }} right  className="profile-dropdown">
				<DropdownItem href="/user/profile" target="_blank">Profile</DropdownItem>				
				<SignoutButton session={props.session} _csrf={props._csrf} />
			</DropdownMenu>
		</Dropdown>
	)
})


const LoginButton = React.memo((props) => {
	return (
		<Button
			style={{
				backgroundColor: '#ff5050',
				fontSize: '13.5px',
				bordeRadius: '5px',
				fontWeight: 600,
				boxShadow: 'none',
				padding: '10px 15px',
				border: 0,
				color: 'white',
				marginRight: '15px'
			}}
			onClick={props.handleLoginClick}
		>
			Log In
		</Button>
	)
})

const Header = props => {
	const {
		logo,
		toggleLogInModal,
		toggleSignUpModal,
		backgroundColor,
		session,
		canonicalUrl,
		stickyTop,
		fixedTop,
		navHeight,
		color,
		width,
		hideSearch,
		tenantConfig,
		subdomain,
		loginBackgroundColor,
		hideOldPlatformLink,
		hideMainMenu,
		_csrf,
		hideLogin,
		store,
		pageType,
		hideHeaderOnScroll,
		headerShadow
	} = props;

	console.log(pageType, subdomain)

	const missionLinks = tenantConfig?.header?.menuLinks?.find(
		menuLink => menuLink.heading === 'Missions'
	)?.missions;
	const causeLinks = tenantConfig?.header?.menuLinks?.filter(
		menuLink => menuLink.heading !== 'Missions'
	);

	const [showExpandedHeader, setShowExpandedHeader] = useState(false);
	const [searchPopoverOpen, setSearchPopoverOpen] = useState(false);
	const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
	const [missionDropdownOpen, setMissionDropdownOpen] = useState(false);
	const [causeDropdownOpen, setCauseDropdownOpen] = useState(false);
	const [donateDropdownOpen, setDonateDropdownOpen] = useState(false);
	const [getinvolvedDropdownOpen, setGetinvolvedDropdownOpen] = useState(false);
	const [user, setUser] = useState(null);
	const [hasUpdateSeen, setHasUpdateSeen] = useState(false);
	const [headerShadowVal, setHeaderShadowVal] = useState(headerShadow || true);

	useEffect(() => {
		if (session?.user) {
			setUser(session.user);
		}
	}, [session]);

	useEffect(() => {
		if (window) {
			if (cookies.read('updates_seen')) {
				setHasUpdateSeen(true);
			}
		}
	}, []);

	useEffect(() => {
		if (showExpandedHeader) {
			document.body.classList.add('expanded-header-open');
		} else {
			document.body.classList.remove('expanded-header-open');
		}
	}, [showExpandedHeader]);

	useEffect(() => {
		if (headerShadowVal !== headerShadow && headerShadow !== undefined) {
			setHeaderShadowVal(headerShadow);
		}
	}, [props?.headerShadow]);

	const updateClicked = e => {
		e.preventDefault();
		Cookie.save('updates_seen', true);
		window.location.href = `/user/reports`;
	};

	const handleCloseExpandedHeader = () => setShowExpandedHeader(false);
	const handleShowExpandedHeader = () => {
		setShowExpandedHeader(true);
		setSearchPopoverOpen(false);
		setProfileDropdownOpen(false);
		setCauseDropdownOpen(false);
		setMissionDropdownOpen(false);
	};
	const toggleSearchPopover = () => {
		setSearchPopoverOpen(!searchPopoverOpen);
		setProfileDropdownOpen(false);
		setCauseDropdownOpen(false);
		setMissionDropdownOpen(false);
	};
	const profileDropdownToggle = () => {
		setProfileDropdownOpen(!profileDropdownOpen);
		setSearchPopoverOpen(false);
		setCauseDropdownOpen(false);
		setMissionDropdownOpen(false);
	};
	const causeDropdownToggle = () => {
		setCauseDropdownOpen(!causeDropdownOpen);
		setProfileDropdownOpen(false);
		setSearchPopoverOpen(false);
		setMissionDropdownOpen(false);
	};
	const missionDropdownToggle = () => {
		setMissionDropdownOpen(!missionDropdownOpen);
		setProfileDropdownOpen(false);
		setSearchPopoverOpen(false);
		setCauseDropdownOpen(false);
	};
	const donateDropdownToggle = input => {
		setDonateDropdownOpen(input);
		setGetinvolvedDropdownOpen(false);
	};
	const getinvolvedDropdownToggle = input => {
		setGetinvolvedDropdownOpen(input);
		setDonateDropdownOpen(false);
	};
	const handleLoginClick = () => {		
		setSearchPopoverOpen(false);
		toggleLogInModal();
	};


	const trackMissionAndCauseClick = (e, eventName, eventInfo) => {
		try {
			if (window.eventDispatcher) {
				window.eventDispatcher.dispatchEventSync(eventName, eventInfo, {
					amplitude: true
				});
			}
		} catch (e) {
			console.log('Error tracking mission and cause click', e);
		}
		return true;
	};

	var hamburgerCircleStyle = showExpandedHeader
		? {
				borderColor: '#444444'
		  }
		: {
				borderColor: color === 'white' ? color : '#444444'
		  };	

	return (
		<>
			<Navbar
				light
				className={`homescreen-header ${
					hideHeaderOnScroll ? '' : 'hs-sticky'
				} ${!showExpandedHeader && headerShadowVal ? 'hs-shadow' : ''} ${
					showExpandedHeader ? 'expanded-header-background-color' : ''
				}`}
				style={{
					backgroundColor: backgroundColor,
					minHeight: '64px',
				}}
			>
				<NavbarToggler
					className="borderless-toggler"
					style={{ cursor: 'pointer' }}
				>
					<SelectByPlatform>
						<GiNavToggler
							name={'www'}
							logo={showExpandedHeader ? 'black' : logo}
							pageType={pageType}
						/>
						<WGNavToggler
							name={'wg'}
							logo={showExpandedHeader ? 'black' : logo}
						/>
					</SelectByPlatform>
				</NavbarToggler>
				<Nav
					className={`ml-auto ${!(
						pageType === 'homepage' ||
						pageType === 'aboutus' ||
						pageType === 'careers' || 
						pageType === 'user-dashboard' || 
						pageType === 'checkout' || 
						pageType === 'monthly-homepage'
					)}`}
				>
					{!showExpandedHeader && (
						<>
							{process.env.APPLICATION_ENV === 'development' &&
								(user?.prdsRole === 'account_manager' ||
									user?.prdsRole === 'payroll_manager') && (
									<NavLink
										className="nav-links-md"
										href={'/prds-dashboard'}
										style={{ textTransform: 'capitalize' }}
									>
										PRDS dashboard
									</NavLink>
								)}
							{!hideLogin && missionLinks?.length > 0 && (
								<Dropdown
									nav
									inNavbar
									isOpen={missionDropdownOpen}
									toggle={missionDropdownToggle}
									onMouseEnter={missionDropdownToggle}
									onMouseLeave={missionDropdownToggle}
								>
									<DropdownToggle
										nav
										className="nav-links-md"
										style={{
											color: color ? color : '#444444',
											textTransform: 'capitalize'
										}}
									>
										Missions
										<FontAwesomeSVGIcon
											icon={faChevronDown}
											className="ml-auto"
											width="7"
										/>
									</DropdownToggle>
									<DropdownMenu right>
										{missionLinks?.map((mission, index) => {
											return (
												<DropdownItem
													href={mission.src}
													key={`missions-link-${index}`}
													onClick={(e, mission) => {
														trackMissionAndCauseClick(e, 'Navbar Mission', {
															mission: mission
														});
													}}
												>
													{mission.heading}
												</DropdownItem>
											);
										})}
									</DropdownMenu>
								</Dropdown>
							)}
							{!hideLogin && subdomain === 'www' && causeLinks?.length > 0 && (
								<Dropdown
									nav
									inNavbar
									isOpen={causeDropdownOpen}
									toggle={causeDropdownToggle}
									onMouseEnter={causeDropdownToggle}
									onMouseLeave={causeDropdownToggle}
								>
									<DropdownToggle
										nav
										className="nav-links-md"
										style={{
											color: color ? color : '#444444',
											textTransform: 'capitalize'
										}}
									>
										Causes
										<FontAwesomeSVGIcon
											icon={faChevronDown}
											className="ml-auto"
											width="7"
										/>
									</DropdownToggle>
									<DropdownMenu>
										{causeLinks?.map((cause, index) => {
											return (
												<DropdownItem
													href={cause.src}
													key={`causes-link-${index}`}
													className={cause.className}
													onClick={(e, cause) => {
														trackMissionAndCauseClick(e, 'Navbar Cause', {
															cause: cause
														});
													}}
												>
													{cause.heading}
												</DropdownItem>
											);
										})}
									</DropdownMenu>
								</Dropdown>
							)}

							{(pageType === 'homepage' ||
								pageType === 'aboutus' ||
								pageType === 'careers') &&
								subdomain === 'www' && (
									<NavLink
										className="nav-links-md nav-link"
										style={{
											color: color ? color : '#444444',
											textTransform: 'capitalize'
										}}
										href={`${config.fundraisersPlatformUrl}start-a-campaign`}
										target="_blank"
									>
										start a fundraiser
									</NavLink>
								)}

							{(pageType === 'homepage' ||
								pageType === 'aboutus' ||
								pageType === 'careers') &&
								subdomain === 'www' && (
									<Dropdown
										nav
										inNavbar
										isOpen={donateDropdownOpen}
										// toggle={donateDropdownToggle}
										onMouseEnter={() => donateDropdownToggle(true)}
										onMouseLeave={() => donateDropdownToggle(false)}
									>
										<DropdownToggle
											nav
											className="nav-links-md"
											style={{
												color: color ? color : '#444444',
												textTransform: 'capitalize'
											}}
										>
											Donate
											<FontAwesomeSVGIcon
												icon={faChevronDown}
												className="ml-auto"
												width="7"
											/>
										</DropdownToggle>
										<DropdownMenu style={{ top: '95%' }} right>
											<DropdownItem href="/monthly" target="_blank">
												Monthly Giving
											</DropdownItem>
											<DropdownItem
												href={`${config.fundraisersPlatformUrl}`}
												target="_blank"
											>
												Fundraisers
											</DropdownItem>
											<DropdownItem
												href="https://covid.giveindia.org"
												target="_blank"
											>
												Covid Missions
											</DropdownItem>
										</DropdownMenu>
									</Dropdown>
								)}

							{(pageType === 'homepage' ||
								pageType === 'aboutus' ||
								pageType === 'careers') &&
								subdomain === 'www' && (
									<Dropdown
										nav
										inNavbar
										isOpen={getinvolvedDropdownOpen}
										// toggle={getinvolvedDropdownToggle}
										onMouseEnter={() => getinvolvedDropdownToggle(true)}
										onMouseLeave={() => getinvolvedDropdownToggle(false)}
									>
										<DropdownToggle
											nav
											className="nav-links-md"
											style={{
												color: color ? color : '#444444',
												textTransform: 'capitalize'
											}}
										>
											Get involved
											<FontAwesomeSVGIcon
												icon={faChevronDown}
												className="ml-auto"
												width="7"
											/>
										</DropdownToggle>
										<DropdownMenu style={{ top: '95%' }} left="true">
											<DropdownItem
												href="https://workplace.giveindia.org/"
												target="_blank"
											>
												Corporate Partnerships
											</DropdownItem>
											<DropdownItem
												href="https://partnerships.giveindia.org/"
												target="_blank"
											>
												Brand &amp; Retail Partnerships
											</DropdownItem>
											<DropdownItem
												href={`${config.fundraisersPlatformUrl}start-a-campaign`}
												target="_blank"
											>
												Fundraise
											</DropdownItem>
											<DropdownItem
												href="https://institutionalgiving.giveindia.org/"
												target="_blank"
											>
												Institutional Giving
											</DropdownItem>
										</DropdownMenu>
									</Dropdown>
								)}

							{(pageType === 'homepage' ||
								pageType === 'aboutus' ||
								pageType === 'careers') &&
								subdomain === 'www' && (
									<div className="nav-links-md" style={{ paddingTop: '0' }}>
										<NavLink
											style={{
												color: color ? color : '#444444',
												textTransform: 'capitalize',
												display: 'flex',
												alignItems: 'center'
											}}
											href="/search"
											target="_blank"
										>
											
											Search
											<SearchIcon
												stroke="#000"
												strokeWidth="5px"
												color={logo === 'white' ? '#fff' : '#000'}
												style={{
													width: '13.5px',
													marginRight: '5px',
													marginTop: '5px',
													marginLeft: '5px'
												}}
											/>
										</NavLink>
									</div>
								)}

							{(pageType === 'homepage' ||
								pageType === 'aboutus' ||
								pageType === 'careers') &&
								subdomain === 'www' && (
									<NavLink href={'/aboutus'} className="nav-links-md">
										About us
									</NavLink>
								)}
														
							{/* WG */}
							{subdomain !== 'www' &&
								// user?.hasDonated &&
								// user?.hasBeneficiaryAssigned &&
								user && (
									<>
										{causeLinks?.length > 0 && (
											<Dropdown
												nav
												inNavbar
												isOpen={causeDropdownOpen}
												toggle={causeDropdownToggle}
												onMouseEnter={causeDropdownToggle}
												onMouseLeave={causeDropdownToggle}
											>
												<DropdownToggle
													nav
													className="nav-links-md"
													style={{
														color: color ? color : '#444444',
														textTransform: 'capitalize'
													}}
												>
													Causes
													<FontAwesomeSVGIcon
														icon={faChevronDown}
														className="ml-auto"
														width="7"
													/>
												</DropdownToggle>
												<DropdownMenu>
													{causeLinks?.map((cause, index) => {
														return (
															<DropdownItem
																href={cause.src}
																key={`causes-link-${index}`}
																className={cause.className}
																onClick={(e, cause) => {
																	trackMissionAndCauseClick(e, 'Navbar Cause', {
																		cause: cause
																	});
																}}
															>
																{cause.heading}
															</DropdownItem>
														);
													})}
												</DropdownMenu>
											</Dropdown>
										)}
										<NavLink
											className="nav-links-md"
											id="search-popover"
											onMouseEnter={toggleSearchPopover}
										>
											<SearchIcon
												stroke="#000"
												strokeWidth="5px"
												color={color ? color : '#444444'}
												style={{ width: '12px' }}
											/>
										</NavLink>
										<div onMouseLeave={toggleSearchPopover}>
											<Popover
												className="search-section"
												placement="bottom"
												trigger="click"
												target="search-popover"
												isOpen={searchPopoverOpen}
												toggle={toggleSearchPopover}
											>
												<PopoverBody>
													<QuickSearch placeholder="Search" />
												</PopoverBody>
											</Popover>
										</div>
										{/* <NavLink
											href={'/aboutus'}
											className="nav-links-md"
											onClick={e => updateClicked(e)}
										>
											UPDATES
											{!hasUpdateSeen && user?.updates?.count > 0 && (
												<span className="notification-alert badge alert">
													{user.updates.count}
												</span>
											)}
										</NavLink> */}
									</>
								)}
							{/* WG */}
						
							{subdomain !== 'www' ? null : hideSearch ? null : (
								<React.Fragment>
									{!hideLogin && (
										<NavLink
											className="nav-links-md"
											id="search-popover"
											onMouseEnter={toggleSearchPopover}
										>
											<SearchIcon
												stroke="#000"
												strokeWidth="5px"
												color={color ? color : '#444444'}
												style={{ width: '12px' }}
											/>
										</NavLink>
									)}
									{!hideLogin && (
										<div onMouseLeave={toggleSearchPopover}>
											<Popover
												className="search-section"
												placement="bottom"
												trigger="click"
												target="search-popover"
												isOpen={searchPopoverOpen}
												toggle={toggleSearchPopover}
											>
												<PopoverBody>
													<QuickSearch placeholder="Search" />
												</PopoverBody>
											</Popover>
										</div>
									)}
								</React.Fragment>
							)}							
						</>
					)}
					
					{!hideLogin && subdomain === 'www' && (
						<NavLink
							className="navbar-toggler-icon-container"
							onClick={
								showExpandedHeader
									? handleCloseExpandedHeader
									: handleShowExpandedHeader
							}
						>
							<div
								className="navbar-toggler-icon-circle"
								style={hamburgerCircleStyle}
							>
								{!showExpandedHeader ? (
									<BurgerNavMenu backgroundColor={backgroundColor} />
								) : (
									// <span className="navbar-dark-toggler-icon toggler-icon"></span>
									<img
										src={`${config.cdnUrl}/static/icons/close.svg`}
										alt="close"
										style={{ height: '1rem' }}
										className="close-icon toggler-icon"
									/>
								)}
							</div>
						</NavLink>
					)}

					{(pageType === 'homepage' ||
						pageType === 'aboutus' ||
						pageType === 'careers' ||  
						pageType === 'user-dashboard' || 
						pageType === 'homepage' || 
						pageType === 'missions' ||
						pageType === 'search' ||
						pageType === 'program' ||
						pageType === 'category' ||
						pageType === 'contactus' ||
						pageType === 'thankyou' ||
						pageType === 'monthly-homepage' ) &&
						subdomain === 'www' && !session.user && (
							<LoginButton handleLoginClick={handleLoginClick} />
						)}	
									
					{(pageType === 'homepage' ||
						pageType === 'aboutus' ||
						pageType === 'careers' ||
						pageType === 'user-dashboard' || 
						pageType === 'homepage' || 
						pageType === 'missions' ||
						pageType === 'search' ||
						pageType === 'program' ||
						pageType === 'category' ||
						pageType === 'contactus' ||
						pageType === 'thankyou' ||
						pageType === 'monthly-homepage' ) &&
						subdomain === 'www' && session.user && (
							<LoggedInUserAvatar 
								profileDropdownOpen={profileDropdownOpen}
								profileDropdownToggle={profileDropdownToggle}
								session={session}
								user={session.user}
								_csrf={_csrf}
							/>									
					)}

					{	subdomain !== 'www' && session.user && (
							<WPGLoggedInUserAvatar 
								profileDropdownOpen={profileDropdownOpen}
								profileDropdownToggle={profileDropdownToggle}
								session={session}
								user={session.user}
								_csrf={_csrf}
							/>									
					)}

					{hideLogin && subdomain === 'www' && (
						<MediaQuery maxWidth={992} device={{ width }}>
							<NavLink
								className="navbar-toggler-icon-container"
								onClick={
									showExpandedHeader
										? handleCloseExpandedHeader
										: handleShowExpandedHeader
								}
							>
								<div
									className="navbar-toggler-icon-circle"
									style={hamburgerCircleStyle}
								>
									{!showExpandedHeader ? (
										<BurgerNavMenu backgroundColor={backgroundColor} />
									) : (
										<img
											src={`${config.cdnUrl}/static/icons/close.svg`}
											alt="close"
											style={{ height: '1rem' }}
											className="close-icon toggler-icon"
										/>
									)}
								</div>
							</NavLink>
						</MediaQuery>
					)}
					{subdomain !== 'www' && user && (
						<MediaQuery maxWidth={992} device={{ width }}>
							<NavLink
								className="navbar-toggler-icon-container"
								onClick={
									showExpandedHeader
										? handleCloseExpandedHeader
										: handleShowExpandedHeader
								}
							>
								<div
									className="navbar-toggler-icon-circle"
									style={hamburgerCircleStyle}
								>
									{!showExpandedHeader ? (
										<BurgerNavMenu backgroundColor={backgroundColor} />
									) : (
										<img
											src={`${config.cdnUrl}/static/icons/close.svg`}
											alt="close"
											style={{ height: '1rem' }}
											className="close-icon toggler-icon"
										/>
									)}
								</div>
							</NavLink>
						</MediaQuery>
					)}
				</Nav>
			</Navbar>
			{showExpandedHeader && (
				<Container fluid className="homescreen-header-expanded">
					<Row className={!hideHeaderOnScroll ? 'expanded-header-margin' : ''}>
						<Col
							md={11}
							xs={12}
							className={`part-2 order-md-2 ${
								!hideHeaderOnScroll ? 'expanded-header-padding' : ''
							}`}
						>
							{subdomain === 'www' ? (
								!hideLogin ? (
									<Row>
										{!hideSearch && (
											<Col md={12} className="search-section-mob">
												<QuickSearch
													placeholder="Search"
													hideRecommendations={true}
												/>
											</Col>
										)}

										<Col md xs={6} className="sub-links order-md-2">
											{missionLinks?.length > 0 && (
												<ul>
													<li className="heading">Missions</li>
													{missionLinks?.map((mission, index) => {
														return (
															<li key={`missions-link-${index}`}>
																<a
																	href={mission.src}
																	onClick={(e, mission) => {
																		trackMissionAndCauseClick(
																			e,
																			'Extended Navbar Mission',
																			{ mission: mission }
																		);
																	}}
																>
																	{mission.heading}
																</a>
															</li>
														);
													})}
												</ul>
											)}
										</Col>
										<Col md xs={6} className="main-links order-md-1">
											<ul>
												<li>
													<a href={'/aboutus'}>About Us</a>
												</li>
												<li>
													<a
														href={`${config.fundraisersPlatformUrl}`}
														target="_blank"
													>
														GiveIndia Fundraisers
													</a>
												</li>
												<li>
													<a
														href="https://workplace.giveindia.org/"
														target="_blank"
													>
														Workplace Giving
													</a>
												</li>
												<li>
													<a href={'/certified-indian-ngos'}>Partner NGOs</a>
												</li>
												<li>
													<a href={'/all-ngos'}>NGOs in India</a>
												</li>
												<li>
													<a href={'https://gi.giveindia.org/'} target="_blank">
														Previous Platform
													</a>
												</li>
												<li>
													<a href={'/giveassured'}>GiveAssured</a>
												</li>
											</ul>
										</Col>

										<Col md xs={6} className="sub-links order-md-3">
											{causeLinks?.length > 0 && (
												<ul>
													<li className="heading">Causes</li>
													{causeLinks?.map((cause, index) => {
														return (
															<li key={`causes-link-${index}`}>
																<a
																	href={cause.src}
																	onClick={(e, cause) => {
																		trackMissionAndCauseClick(
																			e,
																			'Extended Navbar Cause',
																			{ cause: cause }
																		);
																	}}
																>
																	{cause.heading}
																</a>
															</li>
														);
													})}
												</ul>
											)}
										</Col>
										<Col md xs={6} className="main-links order-md-4">
											<ul>
												<li>
													<a
														href={'https://www.giveindia.org/blog/post-page/'}
														target="_blank"
													>
														Blogs
													</a>
												</li>
												<li>
													<a href={'/careers'}>Careers</a>
												</li>
												<li>
													<a
														href={'https://support.giveindia.org/support/home'}
														target="_blank"
													>
														Help
													</a>
												</li>
												<li>
													<a href={'/contactus'}>Contact Us</a>
												</li>
												{/* <li>
											<a>Login</a>
										</li> */}
											</ul>
										</Col>
									</Row>
								) : (
									<Row>
										<Col md xs={12} className="main-links order-md-1">
											<ul>
												<li>
													<a
														href={`${config.fundraisersPlatformUrl}start-a-campaign`}
														target="_blank"
													>
														Start a Fundraiser
													</a>
												</li>
												<li>
													<span className="ham-heading">Donate</span>
													<ul>
														<li>
															<a href="/monthly" target="_blank">
																Monthly Giving
															</a>
														</li>
														<li>
															<a
																href={`${config.fundraisersPlatformUrl}`}
																target="_blank"
															>
																Fundraisers
															</a>
														</li>
														<li>
															<a
																href="https://covid.giveindia.org"
																target="_blank"
															>
																Covid Missions
															</a>
														</li>
													</ul>
												</li>
												<li>
													<span className="ham-heading">Get Involved</span>
													<ul>
														<li>
															<a
																href="https://workplace.giveindia.org/"
																target="_blank"
															>
																Corporate Partnerships
															</a>
														</li>
														<li>
															<a
																href="https://partnerships.giveindia.org/"
																target="_blank"
															>
																Brand &amp; Retail Partnerships
															</a>
														</li>
														<li>
															<a
																href={`${config.fundraisersPlatformUrl}start-a-campaign`}
																target="_blank"
															>
																Fundraise
															</a>
														</li>
														<li>
															<a
																href="https://institutionalgiving.giveindia.org/"
																target="_blank"
															>
																Institutional Giving
															</a>
														</li>
													</ul>
												</li>
												<li>
													<NavLink
														className="nav-links-md"
														style={{
															color: color ? color : '#444444',
															textTransform: 'capitalize',
															display: 'flex',
															justifyContent: 'left',
															alignItems: 'center',
															padding: '0'
														}}
														href="/search"
														target="_blank"
													>
														<SearchIcon
															stroke="#000"
															strokeWidth="5px"
															color={logo === 'white' ? '#fff' : '#000'}
															style={{
																width: '13.5px',
																marginRight: '5px',
																marginTop: '5px'
															}}
														/>
														Search
													</NavLink>
												</li>
												<li>
													<a href="/aboutus" target="_blank">
														About Us
													</a>
												</li>
											</ul>
										</Col>
									</Row>
								)
							) : (
								<Row>
									<Col md={12} className="search-section-mob">
										<QuickSearch
											placeholder="Search"
											hideRecommendations={true}
										/>
									</Col>
									<Col md={12} className="sub-links order-md-1">
										{causeLinks?.length > 0 && (
											<ul>
												<li className="heading">Causes</li>
												{causeLinks?.map((cause, index) => {
													return (
														<li key={`causes-link-${index}`}>
															<a
																href={cause.src}
																onClick={(e, cause) => {
																	trackMissionAndCauseClick(
																		e,
																		'Extended Navbar Cause',
																		{ cause: cause }
																	);
																}}
															>
																{cause.heading}
															</a>
														</li>
													);
												})}
											</ul>
										)}
									</Col>
								</Row>
							)}
						</Col>
						<Col
							md={1}
							xs={12}
							className={`part-1 order-md-1 ${
								!hideHeaderOnScroll ? 'expanded-header-padding' : ''
							}`}
						>
							<div className="header-social-icons">
								<span>
									<a
										rel="noopener noreferrer"
										href="https://www.facebook.com/GiveIndia/"
										target="_blank"
									>
										<FacebookIcon
											style={{ display: 'flex', alignItems: 'center' }}
											size={20}
											color={`${COLORS.giveMidGrey}`}
										/>
									</a>
								</span>
								<span>
									<a
										rel="noopener noreferrer"
										href="https://twitter.com/giveindia/"
										target="_blank"
									>
										<TwitterIcon
											style={{ display: 'flex', alignItems: 'center' }}
											size={20}
											color={`${COLORS.giveMidGrey}`}
										/>
									</a>
								</span>
								<span>
									<a
										rel="noopener noreferrer"
										href="https://www.instagram.com/give_india/"
										target="_blank"
									>
										<InstagramIcon
											style={{ display: 'flex', alignItems: 'center' }}
											size={20}
											color={`${COLORS.giveMidGrey}`}
										/>
									</a>
								</span>
								<span>
									<a
										rel="noopener noreferrer"
										href="https://www.linkedin.com/company/giveindia/"
										target="_blank"
									>
										<LinkedinIcon
											style={{ display: 'flex', alignItems: 'center' }}
											size={20}
											color={`${COLORS.giveMidGrey}`}
										/>
									</a>
								</span>
							</div>
						</Col>
					</Row>
				</Container>
			)}
		</>
	);
};

export default Header;
